<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useIsSystemAdmin } from '@/composables/useIsSystemAdmin';
import PaymentReconciliationPanel from '@/components/payments/PaymentReconciliationPanel.vue';

const { t } = useI18n({ useScope: 'global' });
const { isSystemAdmin } = useIsSystemAdmin();
</script>

<template>
  <div class="prpage">
    <div class="prpage__header">
      <h1 class="prpage__title">{{ t('paymentReconciliation.title') }}</h1>
      <p class="prpage__subtitle">{{ t('paymentReconciliation.subtitle') }}</p>
    </div>

    <div v-if="!isSystemAdmin" class="prpage__forbidden">
      <i class="pi pi-lock" />
      <p>{{ t('paymentReconciliation.forbidden') }}</p>
    </div>
    <PaymentReconciliationPanel v-else />
  </div>
</template>

<style scoped>
.prpage {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2.5rem 3rem;
  box-sizing: border-box;
}
@media (max-width: 1023px) {
  .prpage {
    padding: 1.5rem;
  }
}
.prpage__title {
  margin: 0 0 0.15rem;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--nxt-on-surface);
}
.prpage__subtitle {
  margin: 0;
  font-size: 0.875rem;
  color: var(--nxt-on-surface-muted);
}
.prpage__forbidden {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 4rem 1rem;
  color: var(--nxt-on-surface-muted);
}
.prpage__forbidden i {
  font-size: 2rem;
  opacity: 0.4;
}
</style>
